import { RoutesTable } from './../../resources/routes-table.model';
import { FilesAction } from './files.actions';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { share, map, catchError, switchMap, exhaustMap } from 'rxjs/operators';
import { Action, Store } from '@ngrx/store';
import { ErrorsType } from '../../enum/errors.type';
import { AppState } from '../../interfaces/app-state.interface';
import { BackendService } from '../../services/backend/backend.service';
import { DefaultResponse } from '../../models/form/DefaultResponse';
import { NetworkService } from '../../services/network.services';
FilesAction

@Injectable()
export class FilesEffects {
    /**
     * Obtem um arquivo especifico que vai ser retornando um blob
     * @method getFile
     */
    getBlobFile$ = createEffect(() => this.actions$
        .pipe(
			ofType(FilesAction.getBlobFile),
            switchMap((action: any) => {
                const url = RoutesTable.composeUri(RoutesTable.corporation.routes.getBlobFile, action.payload.id);
                return this.dataService.get<DefaultResponse>(url)
                    .pipe(
                        map((result) => {
                            if (result.ok) {
                                return { type: FilesAction.getBlobFileSuccess, payload: result.value };
                            }
                            return { type: FilesAction.getBlobFileSuccess, payload: result };
                        }),
                        catchError(error => of({ type: FilesAction.getBlobFileError, payload: error })),
                    );
            }),
            share(),
    ));

    /**
     * Obtem um arquivo especifico que vai ser retornando um blob
     * @method getFile
     */
    getLogoFile$ = createEffect(() => this.actions$
        .pipe(
			ofType(FilesAction.getLogoFile),
            switchMap((action: any) => {
                const url = RoutesTable.composeUri(RoutesTable.hubUrls.routes.getLogoFile, action.payload.id);
                return this.dataService.get(url)
                    .pipe(
                        map(result => {
                            return { type: FilesAction.getLogoFileSuccess, payload: result };
                        }),
                        map(blob => {
                            return { type: FilesAction.getLogoFileSuccess, payload: blob };
                        }),
                        catchError(error => of({ type: FilesAction.getLogoFileError, payload: error })),
                    );
            }),
            share(),
        ));

    /**
     * Obtem um arquivo especifico que vai ser retornando uma url
     * @method getFile
     */
    getFullFile$ = createEffect(() => this.actions$
        .pipe(
			ofType(FilesAction.getFullFile),
            exhaustMap((action: any) => {
                return this.dataService.getFile(`agreement/${action.payload.id}/download`)
                    .pipe(
                        map((result) => {
                            this.networkService.downloadFile(result, action.payload.name)
                            return { type: FilesAction.getFullFileSuccess, payload: result }
                        }),
                        catchError(error => of({ type: FilesAction.getFullFileError, payload: error })),
                    );
            }),
            share(),
        ));

    constructor(private actions$: Actions,
                private dataService: BackendService,
                private store$: Store<AppState>,
                private networkService: NetworkService ) {}

}
